import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TAndCRequestBoxComponent } from './t-and-c-request-box.component';

const modules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
];

@NgModule({
    imports: modules,
    exports: [TAndCRequestBoxComponent],
    declarations: [TAndCRequestBoxComponent]
})
export class TAndCRequestBoxModule {}
